import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { AuthenticationService } from '../../services/authentication.service';

type LangCode = "IT" | "EN" | "DE" | "FR" | "ES";

@Component({
  selector: 'app-upload-file-panel',
  imports: [MatIconModule, MatFormFieldModule, MatSelectModule, CommonModule, MatProgressSpinnerModule],
  templateUrl: './upload-file-panel.component.html',
  styleUrl: './upload-file-panel.component.scss'
})
export class UploadFilePanelComponent {

   @Input() selectedLang: LangCode | "" = "";
   @Input() isUploading = false;

   @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;
   
   private _pendingFile: File | null = null;

   @Input() 
   set pendingFile(value: File | null){
      this._pendingFile = value;
      if(value === null && this.fileInputRef){
        this.fileInputRef.nativeElement.value = '';
      }
   }
   get pendingFile(): File | null {
      return this._pendingFile;
   }


   @Output() uploadFile = new EventEmitter<{ file: File; lang: LangCode }>();
   @Output() deleteFile = new EventEmitter<void>();
   @Output() langChange = new EventEmitter<LangCode | ''>();
   @Output() fileSelectedEvent = new EventEmitter<File | null>();

   languages: { code: LangCode; label: string }[] = [
    { code: "IT", label: "Italiano" },
    { code: "EN", label: "English" },
    { code: "DE", label: "Deutsch" },
    { code: "FR", label: "Français" },
    { code: "ES", label: "Español" },
  ];

    constructor(private readonly auth: AuthenticationService){}

   // ===== Upload =====
    openFileDialog(input: HTMLInputElement): void {
      input.click();
    }
  
    onFileSelected(event: Event): void {
      const input = event.target as HTMLInputElement | null;
      const file = input?.files?.[0] ?? null;
      this.pendingFile = file;
      this.fileSelectedEvent.emit(file);
    }
  
    removeFile(input: HTMLInputElement): void {
      input.value = '';
      this.pendingFile = null;
      this.deleteFile.emit();
    }
  
    onUpload(): void {
      if(!this.pendingFile || !this.selectedLang) return;
      this.uploadFile.emit({ file: this.pendingFile, lang: this.selectedLang });
    }

    changeLang(lang: LangCode | ''): void {
      this.selectedLang = lang;
      this.langChange.emit(lang);
    }

    canDoActions(role: string): boolean {
      return this.auth.hasRole(role);
    }
  
}
